import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories";
import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import image from "../../assets/physical-security/bullet/g6-pro-bullet.png";
import type { Product } from "../../types";
import { bullet as bulletProductListGroup } from "../product-list-groups/bullet";
import { deployment, outdoorReady } from "../properties";

export const g6ProBullet: Product = {
  id: "g6ProBullet",
  productTitle: "G6 Pro Bullet",
  description: "g6ProBullet.description",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g6-pro-bullet`,
  ],
  storePathParts: {
    productSlug: "uvc-g6-pro-bullet",
    category: UniFiChildCategorySlug.CamerasBullet,
  },
  image: { src: image, width: 200, height: 140 },
  isNew: true,
  productListGroup: bulletProductListGroup,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Without mount:\nØ85.8 x 106.2 mm (Ø3.4 x 4.2")\nWith mount:\nØ85.8 x 210 mm (Ø3.4 x 8.3")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.2" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: { type: "translation", value: "g6ProBullet.fieldOfView" },
    },
    {
      propertyId: "nightVision",
      value: { type: "translation", value: "g6ProBullet.nightVision" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "string", value: "2.36x" },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
